import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Sidebar from "../../components/common/Sidebar";
import Header from "../../components/common/Header";
import client from "../../services/Client";
import Loading from "../../components/loader/Loading";
import arrowLeft from "../../asessts/Images/arrow_left.svg";
import { formatRole } from "../../utils/common";
import ImagePreviewModal from "../../components/common/ImagePreviewModal";

const ProfessionalDetailsPage = ({ apiType, label }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({});
  const [selectedImage, setSelectedImage] = useState(null);

  // console.log("data?.schedule", data?.schedule);

  const fetchDetails = async () => {
    setIsLoading(true);
    try {
      const response = await client.get(
        `/admin/healthProfessional/get-${apiType}/${id}`
      );
      setData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchDetails();
    }
  }, [id]);

  return (
    <>
      <div className="admin-dashboard">
        <Sidebar />
        <div className="main-dashboard subadmin-dashboard">
          <Header
            title={
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <img
                  src={arrowLeft}
                  alt="Back"
                  style={{ cursor: "pointer", width: "22px", height: "22px" }}
                  onClick={() => navigate(-1)}
                />
                <span>{label} Details</span>
              </div>
            }
          />
          {isLoading ? (
            <Loading />
          ) : (
            <div>
              <div className="setting-main request-main">
                <div className="setting-details">
                  <div className="basic-detail">
                    <div className="profile-upload">
                      <div className="profile-img">
                        <img src={data?.information?.image} alt="" />
                      </div>
                    </div>
                    <div className="profile-details">
                      <div className="profile-head">
                        <div>
                          <h2>
                            {data?.user?.firstName} {data?.user?.lastName}
                          </h2>
                          <p>
                            <span>Profile ID:</span> {data?.profileId}
                          </p>
                        </div>
                      </div>
                      <div className="input-group">
                        <div className="input-field">
                          <label>Facility/Profession</label>
                          <input
                            type="text"
                            placeholder="Type"
                            value={
                              formatRole(data?.facilityOrProfession) || "--"
                            }
                            readOnly
                          />
                        </div>
                        <div className="input-field">
                          <label>Role</label>
                          <input
                            type="text"
                            placeholder="role"
                            value={formatRole(data?.role) || "--"}
                            readOnly
                          />
                        </div>
                        <div className="input-field">
                          <label>Phone Number</label>
                          <input
                            type="text"
                            placeholder="Phone"
                            value={
                              data?.user?.phoneNumber
                                ? `+${data.user.phoneNumber.dialCode} ${data.user.phoneNumber.number}`
                                : "--"
                            }
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="input-group">
                        <div className="input-field">
                          <label>Email</label>
                          <input
                            type="text"
                            placeholder="Email"
                            value={data?.email || data?.user?.email || "--"}
                            readOnly
                          />
                        </div>
                        <div className="input-field">
                          <label>Address</label>
                          <textarea
                            className="input-address"
                            placeholder="Address"
                            value={data?.information?.address?.add || "--"}
                            readOnly
                          />
                        </div>
                        <div className="input-field">
                          <label>Service Status</label>
                          <input
                            type="text"
                            placeholder="Service Status"
                            value={data?.serviceStatus || "--"}
                            readOnly
                          />
                        </div>
                      </div>
                      <div className="input-group">
                        {data?.information?.additionalText && (
                          <div className="input-field" style={{ width: "48%" }}>
                            <label>Additional Text</label>
                            <textarea
                              placeholder="Description"
                              value={data?.information?.additionalText}
                              readOnly
                            ></textarea>
                          </div>
                        )}
                        {data?.professionalDetails?.speciality && (
                          <div className="input-field">
                            <label>Specialty</label>
                            <textarea
                              placeholder="Speciality"
                              value={data?.professionalDetails?.speciality}
                              readOnly
                            ></textarea>
                          </div>
                        )}
                        {data?.professionalDetails?.qualification ? (
                          <div
                            className="input-field"
                            style={{ width: "100%" }}
                          >
                            <label>Qualification</label>
                            <textarea
                              placeholder="Qualification"
                              value={data?.professionalDetails?.qualification}
                              readOnly
                            ></textarea>
                          </div>
                        ) : (
                          <div
                            className="input-field"
                            style={{ width: "100%" }}
                          >
                            <label>Qualification</label>
                            <textarea
                              placeholder="Qualification"
                              value={data?.professionalDetails?.qualifications}
                              readOnly
                            ></textarea>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {data?.schedule ? (
                <div className="doctors-details">
                  <h3>Schedule</h3>
                  <div className="doc-main doc-table-request">
                    <div className="doc">
                      {data?.schedule?.slots?.map((slot, index) => (
                        <table key={index} className="schedule-table">
                          <thead>
                            {/* <tr className="pb-3">
                              <td className="service-name" colSpan="2">
                                Service Name : {service.name}
                              </td>
                            </tr> */}
                            <tr>
                              <th className="col-time">Time</th>
                              <th className="col-days">Days Available</th>
                            </tr>
                          </thead>

                          <tbody>
                            {/* {service.slots.map((slot, slotIndex) => ( */}
                            <tr>
                              <td className="custom-td col-time">
                                {slot.startTime} - {slot.endTime}
                              </td>
                              <td className="custom-td col-days">
                                {slot.days.join(", ")}
                              </td>
                            </tr>
                            {/* ))} */}
                            <div className="mt-3">
                              <strong>Consultation Fees:</strong> ₦{" "}
                              {data?.schedule?.consultationFees || "0"}
                            </div>
                          </tbody>
                        </table>
                      ))}
                    </div>
                  </div>
                </div>
              ) : (
                // <div className="request-document">
                //   <h4>Schedule </h4>
                //   <div className="other-services-container">
                //     {data?.schedule?.slots?.map((slot, index) => (
                //       <div className="service-card" key={index}>
                //         <div style={{ marginBottom: "8px" }}>
                //           <strong>Days:</strong> {slot.days.join(", ")}
                //         </div>
                //         <div style={{ marginBottom: "8px" }}>
                //           <strong>Time:</strong> {slot.startTime} -{" "}
                //           {slot.endTime}
                //         </div>
                //         <div>
                //           <strong>Consultation Fees:</strong> ₦
                //           {data?.schedule?.consultationFees || "0"}
                //         </div>
                //       </div>
                //     ))}
                //   </div>
                // </div>
                <div className="doctors-details">
                  <h3>Schedule</h3>
                  <div className="doc-main doc-table-request">
                    <div className="doc">
                      {data?.serviceAndSchedule?.map((service, index) => (
                        <table key={index} className="schedule-table">
                          <thead>
                            <tr className="pb-3">
                              <td className="service-name" colSpan="2">
                                Service Name: {service.name}
                              </td>
                            </tr>
                            <tr>
                              <th className="col-time">Time</th>
                              <th className="col-days">Days Available</th>
                            </tr>
                          </thead>

                          <tbody>
                            {service.slots.map((slot, slotIndex) => (
                              <>
                                <tr key={slotIndex}>
                                  <td className="custom-td col-time">
                                    {slot.startTime} - {slot.endTime}
                                  </td>
                                  <td className="custom-td col-days">
                                    {slot.days.join(", ")}
                                  </td>
                                </tr>
                                <span className="mt-2">
                                  Price: ₦{service.serviceFees}{" "}
                                </span>
                              </>
                            ))}
                          </tbody>
                        </table>
                      ))}
                    </div>
                  </div>
                </div>
              )}
              {data?.professionalDocuments && (
                <div className="request-document">
                  <h3>Professional Documents</h3>
                  <div className="doc-main">
                    <div>
                      {data?.professionalDocuments?.certificate && (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(
                                data?.professionalDocuments?.certificate
                              )
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={data?.professionalDocuments?.certificate}
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>
                              {data?.professionalDocuments &&
                              Object.keys(data.professionalDocuments).length > 0
                                ? "Certificate"
                                : "No document available"}
                            </span>
                          </div>
                        </div>
                      )}
                      {data?.professionalDocuments?.license && (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(
                                data?.professionalDocuments?.license
                              )
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={data?.professionalDocuments?.license}
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>
                              {data?.professionalDocuments &&
                              Object.keys(data.professionalDocuments).length > 1
                                ? "License"
                                : "No document available"}
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
              {data?.personalDocuments && (
                <div className="request-document">
                  <h3>Personal Documents</h3>
                  <div className="doc-main">
                    <div>
                      {data?.personalDocuments?.nimc && (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(data?.personalDocuments?.nimc)
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={data?.personalDocuments?.nimc}
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>NIMC</span>
                          </div>
                        </div>
                      )}
                      {data?.personalDocuments?.license && (
                        <div className="doc">
                          <div
                            className="doc-file"
                            onClick={() =>
                              setSelectedImage(data?.personalDocuments?.license)
                            }
                          >
                            <img
                              style={{ width: "100%", height: "100%" }}
                              src={data?.personalDocuments?.license}
                              alt=""
                            />
                          </div>
                          <div className="Document-name">
                            <span>License</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      {selectedImage && (
        <ImagePreviewModal
          imageUrl={selectedImage}
          onClose={() => setSelectedImage(null)}
        />
      )}
    </>
  );
};

export default ProfessionalDetailsPage;
